import React, { useEffect, useMemo, useState } from 'react';
import { COLORS } from '../../../styles/tokens';
import { fieldLabelStyle } from './IconField';
import { addPhotos, MAX_ORDERER_PHOTOS } from '../../../utils/ordererPhotos';

// Valgfrie bilder av adkomst og lasteplass. Filene ligger i skjemaets state til oppdraget publiseres.
export default function PhotoPicker({ files, onChange }) {
  const [error, setError] = useState('');
  const previews = useMemo(
    () => files.map((f) => (typeof URL.createObjectURL === 'function' ? URL.createObjectURL(f) : null)),
    [files],
  );
  useEffect(() => () => {
    previews.forEach((u) => { if (u && typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(u); });
  }, [previews]);

  function handlePick(e) {
    const result = addPhotos(files, e.target.files);
    setError(result.error);
    onChange(result.files);
    e.target.value = '';
  }
  const remove = (i) => { setError(''); onChange(files.filter((_, j) => j !== i)); };

  return (
    <div>
      <span style={{ ...fieldLabelStyle, margin: '4px 0 6px' }}>Bilder (valgfritt)</span>
      <div style={styles.hint}>F.eks. adkomst og lasteplass. Maks {MAX_ORDERER_PHOTOS} bilder.</div>
      {files.length > 0 && (
        <ul style={styles.list}>
          {files.map((f, i) => (
            <li key={`${f.name}-${i}`} style={styles.item}>
              {previews[i] && <img src={previews[i]} alt="" style={styles.thumb} />}
              <span style={styles.name}>{f.name}</span>
              <button type="button" aria-label={`Fjern ${f.name}`} style={styles.remove} onClick={() => remove(i)}>✕</button>
            </li>
          ))}
        </ul>
      )}
      {files.length < MAX_ORDERER_PHOTOS && (
        <label style={styles.add}>
          Legg til bilder
          <input type="file" accept="image/*" multiple onChange={handlePick} style={{ display: 'none' }} />
        </label>
      )}
      {error && <div role="alert" style={styles.error}>{error}</div>}
    </div>
  );
}

const styles = {
  hint: { fontSize: 12, color: COLORS.textMid, marginBottom: 8 },
  list: { listStyle: 'none', margin: '0 0 8px', padding: 0, display: 'flex', flexDirection: 'column', gap: 6 },
  item: { display: 'flex', alignItems: 'center', gap: 10, background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 12, padding: '6px 10px' },
  thumb: { width: 40, height: 40, objectFit: 'cover', borderRadius: 8 },
  name: { flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 13.5, color: COLORS.textDark },
  remove: { width: 32, height: 32, borderRadius: '50%', border: `1px solid ${COLORS.border}`, background: COLORS.white, cursor: 'pointer' },
  add: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: 44, padding: '0 18px', borderRadius: 22, border: `1.5px solid ${COLORS.brandPanel}`, color: COLORS.textDark, fontWeight: 600, fontSize: 14, cursor: 'pointer' },
  error: { background: COLORS.dangerBg, color: COLORS.dangerText, padding: '8px 12px', borderRadius: 8, fontSize: 13, marginTop: 8 },
};
